// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"4":"eb2dfe83","343":"3aa6d602","593":"91e900c1","623":"91e900c1"}[chunkId] + ".css";
};